<template>
<div>
    <facilities-list
        :event-type="eventType"
    />
</div>
</template>
    
<script>
import { ref, onUnmounted } from "@vue/composition-api";
import FacilitiesList from '../components/event-list/EventList.vue'

export default {
    components: {
        FacilitiesList
    },
    setup() {
        const eventType = ref('facilities')

        return {
            eventType,
        }
    }
}
</script>